module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detailContent"
  }, [(_vm.linkId != -1) ? _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.form.title))]) : _c('div', {
    staticClass: "title1"
  }, [_vm._v(_vm._s(_vm.form.title))]), _vm._v(" "), (_vm.linkId != -1) ? _c('div', {
    staticClass: "content ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.form.content)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.linkId == -1) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "content",
    attrs: {
      "element-loading-text": "数据提交中，请稍后..."
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.opinion.content),
      expression: "opinion.content",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "placeholder": "请填写反馈内容"
    },
    domProps: {
      "value": (_vm.opinion.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.opinion, "content", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mobile"
  }, [_c('div', [_vm._v("手机号码：")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.opinion.mobile),
      expression: "opinion.mobile",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.opinion.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.opinion, "mobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "code"
  }, [_c('div', [_vm._v("验  证  码：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.opinion.code),
      expression: "opinion.code",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.opinion.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.opinion, "code", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.codeUrl
    },
    on: {
      "click": _vm.refreshCaptcha
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "submitDiv"
  }, [_c('input', {
    staticClass: "submitBtn",
    attrs: {
      "type": "button",
      "value": "提交反馈",
      "loading": _vm.isLoading,
      "disabled": _vm.isReset
    },
    on: {
      "click": _vm.submitForm
    }
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e8e65e1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bottomLink/detail.vue
// module id = 752
// module chunks = 2